import type { RegionCount } from '../apiClient/fetchAdminDashboard';

export const COUNTRIES_GEOJSON_URL =
  'https://raw.githubusercontent.com/nvkelso/natural-earth-vector/master/geojson/ne_110m_admin_0_countries.geojson';

export const US_STATES_GEOJSON_URL =
  'https://raw.githubusercontent.com/nvkelso/natural-earth-vector/master/geojson/ne_110m_admin_1_states_provinces.geojson';

export function buildCountMap(regions: RegionCount[]): Record<string, number> {
  const map: Record<string, number> = {};
  for (const r of regions) {
    map[r.code.toUpperCase()] = r.count;
  }
  return map;
}

export function buildNameMap(regions: RegionCount[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const r of regions) {
    map[r.code.toUpperCase()] = r.name;
  }
  return map;
}

export function joinRegionCounts(
  geojson: GeoJSON.FeatureCollection,
  regions: RegionCount[],
  getCode: (props: GeoJSON.GeoJsonProperties) => string | undefined,
): GeoJSON.FeatureCollection {
  const countsByCode = buildCountMap(regions);
  const namesByCode = buildNameMap(regions);
  const counts = Object.values(countsByCode);
  const maxCount = counts.length > 0 ? Math.max(...counts) : 1;

  return {
    type: 'FeatureCollection',
    features: geojson.features.map((feature) => {
      const code = getCode(feature.properties)?.toUpperCase();
      const count =
        code && countsByCode[code] != null ? countsByCode[code] : 0;
      const regionName =
        (code && namesByCode[code]) ||
        feature.properties?.name ||
        feature.properties?.NAME ||
        code ||
        '';
      return {
        ...feature,
        properties: {
          ...feature.properties,
          regionCode: code || '',
          regionName: String(regionName),
          count,
          normalized: maxCount > 0 ? count / maxCount : 0,
        },
      };
    }),
  };
}

export function filterUsStateFeatures(
  geojson: GeoJSON.FeatureCollection,
): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: geojson.features.filter((f) => {
      const admin = f.properties?.admin || f.properties?.ADMIN || '';
      return String(admin).includes('United States');
    }),
  };
}

export const choroplethFillColor: unknown[] = [
  'interpolate',
  ['linear'],
  ['get', 'count'],
  0,
  '#f7fbff',
  1,
  '#c6dbef',
  10,
  '#6baed6',
  100,
  '#2171b5',
  1000,
  '#08306b',
];
